import {Pipe} from "@angular/core";
import {PlatformLocation} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {GwrGrundstueckListEntry} from "../../../core/gwr-api";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {GwrGrundstuecknummerPipe} from "../../../gwr/gwr-grundstueck-list/gwr-grundstuecknummer.pipe";

@Pipe({
  name: 'kompaktGwrGrundstueck'
})
export class KompaktGwrGrundstueckPipe extends KompaktdarstellungPipe<GwrGrundstueckListEntry> {

  constructor(protected formatConfigService: FormatConfigService,
              protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy,
              private gwrGrundstueckNummerPipe: GwrGrundstuecknummerPipe,
              private translate: TranslateService) {
    super(formatConfigService, 'GRUNDSTUECK', location, kompaktLocation);
  }

  transform(entry: GwrGrundstueckListEntry, languageChangeEvent = 'de'): string {
    if (!entry) {
      return;
    }
    let value = this.gwrGrundstueckNummerPipe.transform(entry.grundstueckNummer);
    if (entry.grundstueckArt != null) {
      value = this.translate.instant(entry.grundstueckArt) + ' ' + value;
    }
    return value;
  }
}
